module.exports = __webpack_public_path__ + "c49b7355a45ab90a791d90c9fd22ae80.png";